/**
 * Single-source-of-truth delivery language resolver.
 *
 * Rule (locked):
 *   Cambridge → 'en' (ALWAYS — student preferences are ignored)
 *   Qatari    → student preference for that subject, else 'ar'
 */

/**
 * Maps Qatari subject names (as returned by /student/subjects) to the
 * field name on the student_data localStorage object that holds the
 * guardian's language preference for that subject.
 */
export const SUBJECT_LANG_FIELD = {
  'التربية الإسلامية':   'islamic_lang',
  'اللغة العربية':       'arabic_lang',
  'تاريخ قطر والمواطنة': 'qatar_history_lang',
};

/**
 * Resolve the delivery language for a (subject, student) pair.
 *
 * @param {object} subject     - Subject object from /student/subjects API response.
 *                               Must have `curriculum_type` ('cambridge'|'qatar')
 *                               and `subject_name` (Arabic or English name string).
 * @param {object|null} studentRaw - Parsed localStorage 'student_data' object, or null.
 * @returns {'en'|'ar'}
 */
export function resolveDeliveryLanguage(subject, studentRaw) {
  if (subject?.curriculum_type === 'cambridge') return 'en';

  const subjectName = subject?.subject_name || subject?.name || '';
  const prefField = SUBJECT_LANG_FIELD[subjectName];

  if (!prefField) {
    // Unknown Qatari subject — conservative default
    return 'ar';
  }

  const pref = studentRaw?.[prefField];
  return (pref === 'ar' || pref === 'en') ? pref : 'ar';
}
